import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-journal-kpi',
  templateUrl: './journal-kpi.component.html',
  styleUrls: ['./journal-kpi.component.scss']
})
export class JournalKpiComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<JournalKpiComponent>) { }

  ngOnInit() {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
